<div class="grid-container margin-top extra-wide">
  <div class="grid-x">
    <div class="cell large-12 medium-12 small-12">
      <ag-grid-angular class="data-grid  full-page" [gridOptions]="gridOptions" [rowData]="alerts" aria-label="System Alerts"></ag-grid-angular>
    </div>
  </div>
  @if (showEditModal) {
    <app-edit-system-alert [showEditModal]="showEditModal"
      [savingAlert]="savingAlert"
      [alert]="selectedAlert"
      (onUpdate)="completeUpdate($event)"
      (onCancel)="handleCancel()">
    </app-edit-system-alert>
  }
  @if (showCreateModal) {
    <app-create-system-alert
      [showCreateModal]="showCreateModal"
      [savingAlert]="savingAlert"
      (onCreate)="completeCreateAlert($event)"
      (onCancel)="handleCancel()">
    </app-create-system-alert>
  }
</div>
